import MatchPlayFullCoverageLink from './match-play-full-coverage-link'

export default MatchPlayFullCoverageLink
